var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-section-anchor"},[_c('a',{on:{"click":_vm.scrollDown}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_downward")])])])}
var staticRenderFns = []

export { render, staticRenderFns }